import React, { useState } from 'react'
import EditIcon from 'assets/images/loans/edit.svg'
import { UseMutateFunction } from 'react-query'
import posthog from 'posthog-js'
import SelectDateModal from 'components/modals/selectDate'
import { WeekConvertor } from './utils'
interface IBodyProps {
    name: string
    bankBalance: number
    interval: string
    shareValue: number
    dayOfDuetion: number
    type: string
    notificationAnnounce: string
    smsAnnounce: string
    id: string | undefined
    refetch: () => void
    imageId: number
    mutate: UseMutateFunction<any, unknown, ISettingImagePayload, unknown>
}
export default function Date({
    name,
    bankBalance,
    interval,
    shareValue,
    dayOfDuetion,
    type,
    notificationAnnounce,
    smsAnnounce,
    id,
    refetch,
    imageId,
    mutate,
}: IBodyProps) {
    const [isSelectedName, setIsSelectedName] = useState<boolean>(false)
    const [isOpen, setIsOpen] = useState(false)
    const [selectedTab, setSelectedTab] = useState<string>(
        interval ? interval : 'wkl'
    )
    const [dateValue, setDateValue] = useState<number>(
        dayOfDuetion ? dayOfDuetion : 0
    )
    return (
        <div>
            {isSelectedName ? (
                <div className=" mx-3">
                    <p className=" text-sm text-gray-4 my-2">تاریخ سررسید</p>
                    <div className=" flex justify-between">
                        <div
                            onClick={() => setIsOpen(true)}
                            className=" w-full "
                        >
                            {selectedTab === 'wkl'
                                ? `هفتگی -هر ${WeekConvertor[dateValue]}`
                                : `ماهانه - ${dateValue} ام هر ماه`}
                        </div>
                        <p
                            className=" text-green-1"
                            onClick={() => {
                                setIsSelectedName(false)
                                const payload: ISettingImagePayload = {
                                    name,
                                    bankBalance,
                                    interval: selectedTab,
                                    shareValue,
                                    dayOfDuetion: dateValue,
                                    type,
                                    notificationAnnounce,
                                    smsAnnounce,
                                    imageId,
                                    id,
                                }
                                posthog.capture('fund_setting_due_date_saved', {
                                    fund_id: id,
                                })
                                mutate(payload)
                            }}
                        >
                            اعمال
                        </p>
                    </div>
                    <hr className=" w-full my-1" />
                </div>
            ) : (
                <div className=" mx-3">
                    <p className=" text-sm text-gray-4 my-2">تاریخ سررسید</p>
                    <div className=" flex justify-between">
                        <p>
                            {selectedTab === 'wkl'
                                ? `هفتگی -هر ${WeekConvertor[dateValue]}`
                                : `ماهانه - ${dateValue} ام هر ماه`}
                        </p>
                        <img
                            src={EditIcon}
                            alt="edit"
                            className=" w-5 h-5"
                            onClick={() => setIsSelectedName(true)}
                        />
                    </div>
                    <hr className=" w-full my-1" />
                </div>
            )}
            <SelectDateModal
                show={isOpen}
                onHide={() => setIsOpen(false)}
                setSelectedTab={setSelectedTab}
                setDateValue={setDateValue}
                selectedTab={selectedTab}
            />
        </div>
    )
}
